export default "__VITE_ASSET__Cu_l4$Rz__"